import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { WikiSidebar } from "./WikiSidebar";
import { ReactNode } from "react";

interface WikiLayoutProps {
  children: ReactNode;
}

export const WikiLayout = ({ children }: WikiLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <div className="flex-1 flex pt-20">
        <WikiSidebar />
        <main className="flex-1 container mx-auto px-4 py-8 max-w-4xl">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};
